import React from "react";
import {Button} from "antd";
import TypeSelect from "../typeSelect/TypeSelect";
import CmSearchInput from "../../../../components/CmSearchInput/CmSearchInput";
import "./ToolBar.css";
import BaseComponent from "../../../../base/BaseComponent";
import CmModal from "../../../../components/CmModal/CmModal";
import {message} from "../../utils/sysManagementUtils";

export default class ToolBar extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            deleteIdsVisible: false,
        }
    }

    render() {
        const {
            searchType,
            onTypeChange,
            searchValue,
            onSearchValueChange,
            onSearch,
            showConfigEdit,
            isParamsConfig,// 是否要批量删除按钮
            onDeleteByIds,// 批量删除方法
            batchDelData,// 批量删除全部
            onDeleteCall//批量删除置空
        }
         = this.props;
        return (
            <>
                <div className="ParamConfiguration-ToolBar">
                    <div>
                        <Button
                            onClick={() => showConfigEdit()}
                            style={{marginRight: "10px"}}
                            type="primary"
                        >新增</Button>
                        {
                            isParamsConfig === 'isParamsConfig' ? <Button
                                onClick={() => this.onDeleteIds()}
                                style={{marginRight: "10px"}}
                            >批量删除</Button> : null
                        }
                    </div>
                    <div className="ParamConfiguration-ToolBar_right">
                        <div className="margin-right-20">
                            <span>类型：</span>
                            <TypeSelect
                                allowClear={true}
                                value={searchType}
                                placeholder="请选择类型"
                                onChange={onTypeChange}
                                style={{width: "200px"}}
                            />
                        </div>

                        <div className="horizontal-center">
                            <span>关键字搜索：</span>
                            <CmSearchInput
                                searchValue={searchValue}
                                onSearch={onSearch}
                                onSearchValueChange={onSearchValueChange}
                                placeholder="请输入参数名称"
                            />
                        </div>
                    </div>
                    <CmModal
                        handleOk={() => {
                            this.state.deleteIdsVisible = false;
                            onDeleteByIds && onDeleteByIds();
                            onDeleteCall&&onDeleteCall();
                        }}
                        handleCancel={this.handleCancel}
                        visible={this.state.deleteIdsVisible}
                        title="批量删除"
                        isDeleteIds={'isDeleteIds'}
                    >
                        <div>以下参数配置将被删除：</div>
                        <div style={{margin:'5px 0'}}>
                            {batchDelData.map(item => item.configName).join("，")}
                        </div>
                    </CmModal>
                </div>
            </>
        );
    }
    onDeleteIds = () => {
        const {batchDelData} = this.props;
        console.log(batchDelData,this.state.deleteIdsVisible);
        if(!batchDelData.length){
            message.error('请选择参数配置！');
            return false
        }
        if (batchDelData.length) {
            this.setState({
                deleteIdsVisible: true
            });
        }
    };
    handleCancel = () => {
        this.setState({
            deleteIdsVisible: false,
        });
    };
}